// extracted by mini-css-extract-plugin
export default {"unavailable":"style_unavailable__wZBTa","unavailableTitle":"style_unavailableTitle__cEvu1"};